export type ProjectType =
  | 'video_contribution'
  | 'video_collection'
  | 'video_capture'
  | 'video_conversation'
  | 'video_compliance'

export const DEFAULT_PROJECT_TYPE: ProjectType = 'video_contribution'

export const getProjectWorkflowDefaults = (projectType: ProjectType) => {
  if (projectType === 'video_conversation') {
    return {
      allowRecordVideo: true,
      allowUploadFile: false,
      allowBatchUpload: false,
      maxFilesPerSubmission: 1,
    }
  }

  if (projectType === 'video_capture') {
    return {
      allowRecordVideo: true,
      maxFilesPerSubmission: 1,
    }
  }

  if (projectType === 'video_collection') {
    return {
      allowUploadFile: true,
      allowBatchUpload: true,
    }
  }

  return {}
}

export const PROJECT_TYPE_OPTIONS: Array<{
  key: ProjectType
  value: ProjectType
  text: string
  workflowName: string
  action: string
  description: string
}> = [
  {
    key: 'video_contribution',
    value: 'video_contribution',
    text: 'Contribution',
    workflowName: 'Single-file submission',
    action: 'Collect one video',
    description:
      'Collect one uploaded or recorded video from your community, customers or colleagues, with reuse rights confirmed.',
  },
  {
    key: 'video_collection',
    value: 'video_collection',
    text: 'Collection',
    workflowName: 'Multi-file submission',
    action: 'Compile several files',
    description: 'Collect several files together with shared contributor details and information about each file.',
  },
  {
    key: 'video_capture',
    value: 'video_capture',
    text: 'Capture',
    workflowName: 'Single prompted response',
    action: 'Record one response',
    description: 'Ask one on-screen question and capture an authentic camera response, such as a testimonial.',
  },
  {
    key: 'video_conversation',
    value: 'video_conversation',
    text: 'Conversation',
    workflowName: 'Video questionnaire',
    action: 'Capture several responses',
    description: 'Ask 2–8 on-screen questions and record a separate camera response to each prompt.',
  },
  {
    key: 'video_compliance',
    value: 'video_compliance',
    text: 'Compliance',
    workflowName: 'Structured visual evidence',
    action: 'Confirm completed work',
    description: 'Capture grouped evidence against a workplace, asset or job, such as Before, During and After.',
  },
]
